import { Routes, Route, Navigate } from "react-router-dom";

import McpLayout from "./layout";
import GetStarted from "./get-started";
import ConnectedApps from "./connected-apps";
import Tools from "./tools";
import Skills from "./skills";

export default function Mcp() {
  return (
    <Routes>
      <Route element={<McpLayout />}>
        <Route path="get-started" element={<GetStarted />} />
        <Route path="connected-apps" element={<ConnectedApps />} />
        <Route path="tools" element={<Tools />} />
        <Route path="skills" element={<Skills />} />
        <Route path="" element={<Navigate to="get-started" replace />} />
      </Route>
    </Routes>
  );
}
